import React from 'react';

const BannerPage = () => {
  const logoUrl = "https://customer-assets.emergentagent.com/job_3887c62b-7cac-4b2d-b17d-6e46f80903f9/artifacts/pcgjlywb_Untitled%20design%20%281%29.png";
  const highResBannerUrl = "/ibg-youtube-banner.png";

  return (
    <div className="min-h-screen bg-gray-100 py-12 px-8">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-3xl font-bold text-gray-700 mb-2 text-center">Banner Assets</h1>
        <p className="text-gray-500 mb-10 text-center">Right-click on any banner to save it, or take a screenshot.</p>
        
        {/* High Resolution PNG Download */}
        <div className="mb-12">
          <h2 className="text-xl font-semibold text-gray-700 mb-4">High Resolution PNG (1536x1024)</h2>
          <div className="bg-white p-4 rounded-xl shadow-lg">
            <img 
              src={highResBannerUrl}
              alt="Independent Board Games YouTube Banner - High Resolution"
              className="w-full max-w-4xl mx-auto rounded-lg shadow-md"
            />
          </div>
          <div className="flex justify-center mt-4">
            <a 
              href={highResBannerUrl}
              download="ibg-youtube-banner.png"
              className="inline-flex items-center gap-2 px-6 py-3 bg-purple-600 hover:bg-purple-700 text-white font-semibold rounded-lg shadow-md transition-colors"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
              Download High-Res PNG (1536x1024)
            </a>
          </div>
        </div>

        {/* Logo Only */}
        <div className="mb-12">
          <h2 className="text-xl font-semibold text-gray-700 mb-4">Logo Only</h2>
          <div className="flex justify-center">
            <div className="bg-purple-600 p-6 rounded-xl shadow-lg">
              <img 
                src={logoUrl} 
                alt="Independent Board Games Logo" 
                className="w-48 h-48 object-contain"
              />
            </div>
          </div>
          <p className="text-sm text-gray-500 mt-3 text-center">
            <a 
              href={logoUrl} 
              download="ibg-logo.png"
              target="_blank"
              rel="noopener noreferrer"
              className="text-purple-600 hover:text-purple-800 underline"
            >
              Click here to download logo
            </a>
          </p>
        </div>

        {/* Instructions */}
        <div className="p-4 bg-white rounded-lg shadow max-w-md mx-auto">
          <p className="text-sm text-gray-600 text-center">
            <strong>Tip:</strong> Use your browser's screenshot tool or right-click and select "Save image as..." to download any banner.
          </p>
        </div>
      </div>
    </div>
  );
};

export default BannerPage;
